import { render, staticRenderFns } from "./modal-email-project.vue?vue&type=template&id=7dc378d8&"
import script from "./modal-email-project.vue?vue&type=script&lang=js&"
export * from "./modal-email-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports